import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=5d6143be&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports